import { useEffect, useState } from 'react';

const DISPLAY_MODES = ['browser', 'standalone', 'minimal-ui', 'fullscreen', 'window-controls-overlay'] as const;

/** Get current display mode */
export function getDisplayMode(): (typeof DISPLAY_MODES)[number] | undefined {
  for (const mode of DISPLAY_MODES) {
    if (window.matchMedia(`(display-mode: ${mode})`).matches) {
      return mode;
    }
  }
}

/** Get current display mode and listen to changes */
export function useDisplayMode() {
  const [displayMode, setDisplayMode] = useState(getDisplayMode());

  useEffect(() => {
    const mediaQueries = DISPLAY_MODES.map(mode => {
      const query = window.matchMedia(`(display-mode: ${mode})`);
      const listener = () => {
        if (query.matches) {
          setDisplayMode(mode);
        }
      };
      query.addEventListener('change', listener);
      return { query, listener };
    });

    return () => {
      mediaQueries.forEach(({ query, listener }) => {
        query.removeEventListener('change', listener);
      });
    };
  }, []);

  return displayMode;
}
